import { FC } from 'react';
import { useIntl } from 'react-intl';

function isDefined(value: number | undefined | null): value is number {
  return value !== null && value !== undefined && !isNaN(value);
}

export const PercentOrAmountValue: FC<{
  percent?: number;
  amount?: number;
  greeksPrecision: number;
  isAlreadyPercent?: boolean;
}> = ({ percent, amount, greeksPrecision, isAlreadyPercent = false }) => {
  const { formatNumber } = useIntl();
  const percentFactor = isAlreadyPercent ? 1 : 100;
  if (isDefined(percent)) {
    return (
      <>
        {formatNumber(percent * percentFactor, {
          maximumFractionDigits: greeksPrecision,
          minimumFractionDigits: greeksPrecision,
        })}
        <span className="fs-6">&nbsp;%</span>
      </>
    );
  }
  if (isDefined(amount)) {
    return (
      <>{formatNumber(amount, { maximumFractionDigits: greeksPrecision, minimumFractionDigits: greeksPrecision })}</>
    );
  }
  return <>_</>;
};

PercentOrAmountValue.displayName = 'PercentOrAmountValue';

export const Value: FC<{ value: number | undefined }> = ({ value }) => {
  const { formatNumber } = useIntl();
  if (value === undefined || isNaN(value)) {
    return <>_</>;
  }
  return <>{formatNumber(value, { maximumFractionDigits: 4 })}</>;
};

Value.displayName = 'Value';

export const Underlying: FC<{ code: string | undefined }> = ({ code }) => {
  return (
    <div className="badge badge-outline-secondary rounded-pill">
      <span className="text-primary">{code}</span>
    </div>
  );
};

Underlying.displayName = 'Underlying';
